"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformServiceRateRequest = exports.transformServiceRateResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Error_1 = require("./Error");
function transformServiceRateResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isProjectErrorResponse)(status, response)) {
        return (0, Error_1.transformProjectErrorResponse)(response);
    }
    const { service_rate } = response;
    return transformServiceRateParsedResponse(service_rate);
}
exports.transformServiceRateResponse = transformServiceRateResponse;
function transformServiceRateParsedResponse(rate) {
    return {
        rate: rate.rate,
        businessId: rate.business_id,
        serviceId: rate.service_id,
    };
}
function transformServiceRateRequest(rate) {
    return JSON.stringify({
        service_rate: {
            rate: rate.rate,
        },
    });
}
exports.transformServiceRateRequest = transformServiceRateRequest;
//# sourceMappingURL=ServiceRate.js.map